<template>
  <div id="page">
    <div align="center" style="margin-top: 48px;">
      <div>
        <img
          src="static/DubaiDIY/img_order_result.png"
          width="96px"
          height="72px"
        />
      </div>
      <div style="margin-top: 8px;">
        <label>The picture is under reviewing</label>
      </div>
      <div style="margin-top: 8px;">
        <label>The review will be done within 24 hours</label>
      </div>
      <div style="margin-top: 8px;">
        <label>Please don't apply for a new card during this period</label>
      </div>
      <div style="margin-top: 8px;">
        <label>Otherwise,the card application may fail</label>
      </div>
      <div style="margin-top: 48px;width: 96px;">
        <b-button block variant="danger" @click="goHomeXy()">Ok</b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderResult_Dubai",
  data() {
    return {};
  },
  mounted: function() {},
  destroyed: function() {},
  methods: {
    goHomeXy() {
      sessionStorage.clear();
      this.$router.push({ name: "Home_Dubai" });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/DubaiCard/OrderResult_Dubai.vue